<div class="profile-demographic-modal">
  @if (canDismiss()) {
    <close-circle-outline
      class="profile-demographic-modal__close"
      (click)="onDismiss()" />
  }

  @let content = currentStep();

  @if (step() > 0) {
    <div
      class="profile-demographic-modal__stepper"
      aria-label="Progreso del perfil demográfico">
      @for (stepNumber of steps; track stepNumber; let last = $last) {
        <div class="profile-demographic-modal__stepper-item">
          <span
            class="profile-demographic-modal__stepper-number body-xs"
            [class.profile-demographic-modal__stepper-number--active]="
              step() >= stepNumber
            "
            [attr.aria-current]="step() === stepNumber ? 'step' : null">
            {{ stepNumber }}
          </span>
          @if (!last) {
            <span
              class="profile-demographic-modal__stepper-connector"
              [class.profile-demographic-modal__stepper-connector--active]="
                step() >= stepNumber
              ">
            </span>
          }
        </div>
      }
    </div>
  }

  @for (paneStep of [step()]; track paneStep) {
    <div
      class="wizard-pane"
      [class.wizard-pane--back]="navDir() === 'back'">
  @if (imageSrc(); as imageSrc) {
    <ui-image
      class="profile-demographic-modal__image"
      [src]="imageSrc"
      alt=""
      aspectRatio="4/3"
      fitBy="height"
      objectFit="contain" />
  }

  <div class="profile-demographic-modal__header">
    <h3 class="profile-demographic-modal__header-title">
      @for (part of content.titleParts; track part.text) {
        @if (part.gradient) {
          <span class="text-gradient-primary">{{ part.text }}</span>
        } @else {
          {{ part.text }}
        }
      }
    </h3>
    <p class="profile-demographic-modal__header-description">
      {{ content.description }}
    </p>

    @if (step() === 0) {
      <tag
        class="profile-demographic-modal__header-tag"
        [active]="true"
        [icon]="ClockOutline"
        label="Solo 3 preguntas" />
    }
  </div>

  @if (step() > 0) {
    @switch (step()) {
      @case (1) {
        <dropdown-form-control
          [(value)]="acquisitionSource"
          [options]="acquisitionSourceOptions"
          [required]="true"
          label="¿Cómo nos conociste?"
          placeholder="Selecciona una opción" />
      }
      @case (2) {
        <datepicker-form-control
          [(value)]="birthDate"
          [required]="true"
          label="Fecha de nacimiento" />
      }
      @case (3) {
        <autocomplete-form-control
          [(value)]="country"
          [options]="countryOptions()"
          [required]="true"
          label="País"
          mode="restricted"
          placeholder="Busca tu país" />
        @if (isPeru()) {
          <autocomplete-form-control
            [(value)]="department"
            [options]="departmentOptions()"
            [required]="true"
            label="Departamento"
            mode="restricted"
            placeholder="Busca tu departamento" />
        }
      }
    }
  }
    </div>
  }

  <div class="profile-demographic-modal__actions">
    @if (step() > 0) {
      <primary-button
        (click)="onBack()"
        [disabled]="loading()"
        [icon]="ArrowLeftOutline"
        iconPosition="left"
        label="Atrás"
        size="medium"
        variant="secondary"
        class="profile-demographic-modal__action" />
    }
    <primary-button
      (click)="onNext()"
      [disabled]="!canContinue()"
      [icon]="isFinalStep() ? SendTwo : ArrowRightOutline"
      [label]="isFinalStep() ? 'Enviar respuestas' : 'Siguiente'"
      [loading]="loading()"
      [variant]="buttonVariant"
      size="medium"
      class="profile-demographic-modal__action" />
  </div>

  <div class="profile-demographic-modal__footer">
    <shield-lock-bold class="profile-demographic-modal__footer-icon" />
    <span>Tu información está segura con nosotros</span>
  </div>
</div>
